import { getStorage } from './localStorage';
import { isAdmin, isOperator, isTeacher } from './acl';

const METHODS = ['get', 'post', 'put', 'delete', 'patch', 'head'];
const isErrorStatus = (status) => status > 399;

export const createHTTPClient = ({ baseURL = '', headers = {} }) => METHODS.reduce((acc, cur) => ({
  ...acc,
  [cur]: async (path = '', options = {}) => {
    const res = await window.fetch(`${baseURL}${path}`, {
      method: cur.toLowerCase(),
      ...options,
      headers: {
        ...headers,
        ...(options.headers || {}),
      },
    });

    if (isErrorStatus(res.status)) {
      throw await res.json();
    }

    if (res.status === 204) {
      return null;
    }
    const json = await res.json();
    return json;
  },
}), {});

const DEFAULT_FILTER = {
  // property: '',
  // operation: '',
  // value: '',
};

export const buildFilters = (...filters) => (
  filters.map(filter => ({ ...DEFAULT_FILTER, ...filter }))
);

export const applyFilterParser = (payload, scope = 'EXAM') => {
  const filterParsed = payload
    .map(({ filters }) => {
      if (!(filters && filters.length)) return;
      const currentFilter = {
        operation: 'IN',
        scope,
        value: [],
      };

      filters.forEach((item) => {
        const filter = item.value || item;
        if (!filter) return null;
        const { dbValue } = filter.getValue();
        currentFilter.value.push(dbValue);
        currentFilter.property = filter.property;
        currentFilter.scope = filter.scope || scope;
        currentFilter.valueType = filter.getValueType();
      });

      currentFilter.value = JSON.stringify(currentFilter.value);
      return currentFilter;
    })
    .filter(filter => !!filter);

  return filterParsed;
};


const cleanFilters = (filters) => {
  const [filter] = filters;
  filter.filterList = filter.filterList.map(({ add, entity, refs }) => ({ add, entity, refs }));
  return [filter];
};

export const applyBuiltInFilters = ({ ignoreFilters = false, customFilters = [] }) => {
  const teacherFilters = {
    add: true,
    entity: 'status_owner',
    builtin: true,
    refs: [getStorage('user')],
  };

  let payload = [...cleanFilters(customFilters)];

  if (isOperator()) {
    payload = ignoreFilters ? [] : [...cleanFilters(customFilters)];
  }

  if (isTeacher()) {
    let filters = [...customFilters];
    filters[0].filterList.push(teacherFilters);
    filters = cleanFilters(filters);
    payload = ignoreFilters ? [] : [...filters];
  }

  if (isAdmin()) {
    payload = ignoreFilters ? [] : [...cleanFilters(customFilters)];
  }

  return payload;
};
